import oculos1 from '../../asserts/img/oculos/1.png'
import oculos2 from '../../asserts/img/oculos/2.png'
import oculos3 from '../../asserts/img/oculos/3.png'
import oculos4 from '../../asserts/img/oculos/4.png'
import oculos5 from '../../asserts/img/oculos/5.png'
import oculos6 from '../../asserts/img/oculos/6.png'
import oculos7 from '../../asserts/img/oculos/7.png'
import oculos8 from '../../asserts/img/oculos/8.png'
import oculos9 from '../../asserts/img/oculos/9.png'
import oculos10 from '../../asserts/img/oculos/10.png'
import oculos11 from '../../asserts/img/oculos/11.png'


export const oculosMascolinoImage = [
    { id: 1, image: oculos5, alt: 'Óculos Masculino Modelo 1' },
    { id: 2, image: oculos6, alt: 'Óculos Masculino Modelo 2' },
    { id: 3, image: oculos7, alt: 'Óculos Masculino Modelo 3' },
    { id: 4, image: oculos9, alt: 'Óculos Masculino Modelo 4' },
];

export const oculosFemininoImage = [
    { id: 1, image: oculos1, alt: 'Óculos Feminino Modelo 1' },
    { id: 2, image: oculos2, alt: 'Óculos Feminino Modelo 2' },
    { id: 3, image: oculos4, alt: 'Óculos Feminino Modelo 3' },
    { id: 4, image: oculos4, alt: 'Óculos Feminino Modelo 4' },
];

export const oculosInfantilImage = [
    { id: 1, image: oculos8, alt: 'Óculos Infantil Modelo 1' },
    { id: 2, image: oculos10, alt: 'Óculos Infantil Modelo 2' },
    { id: 3, image: oculos11, alt: 'Óculos Infantil Modelo 3' },
];